import { useRef, useState } from "react";
import { Button, Input, Label } from "reactstrap";
import BarcodeSticker from "../ui/BarcodeSticker";

function PatientBarcodes(props: any) {
  const [selectedBarcodes, setSelectedBarcodes] = useState<string[]>([]);
  const { patient } = props;
  const barcodeRef = useRef<HTMLDivElement>(null);
  console.log(props);

  const handleCheckPrint = (barcode: string, isSelected: boolean) => {
    let barcodeList: any = [...selectedBarcodes];
    if (isSelected) {
      barcodeList.push(barcode);
    } else {
      barcodeList = barcodeList.filter((e: string) => barcode !== e);
    }
    setSelectedBarcodes(barcodeList);
  };
  const printInvoice = () => {
    if (!barcodeRef.current) {
      console.error("Barcode reference is null");
      return;
    }

    // Create a hidden print container
    const printContainer = document.createElement("div");
    printContainer.id = "print-container";
    printContainer.innerHTML = barcodeRef.current.innerHTML;

    // Apply styles to match UI and prevent page breaks
    printContainer.style.position = "absolute";
    printContainer.style.top = "0";
    printContainer.style.left = "0";
    printContainer.style.width = "100%";
    printContainer.style.backgroundColor = "#fff";
    printContainer.style.padding = "10mm";
    printContainer.style.fontSize = "14px";
    printContainer.style.display = "flex";
    printContainer.style.flexWrap = "wrap";
    printContainer.style.justifyContent = "center";

    document.body.appendChild(printContainer);

    // Add print styles
    const style = document.createElement("style");
    style.innerHTML = `
      @media print {
        body * {
          visibility: hidden;
        }
        #print-container, #print-container * {
          visibility: visible;
        }
        #print-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          width: 100%;
          transform: scale(0.9); /* Adjust scaling to fit all barcodes */
        }
        .barcodes-content-container {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          width: auto;
          display: inline-block;
          margin: 5px;
        }
          input[type="checkbox"] {
      display: none !important;
    }
      .print-label {
    display: none !important; /* Hides the print-related labels during printing */
  }
      }
    `;
    document.head.appendChild(style);

    // Print and clean up
    window.print();
    document.body.removeChild(printContainer);
    document.head.removeChild(style);
  };

  const selectAll = () => {
    setSelectedBarcodes([
      "STOOL",
      "URINE",
      "BLOOD-CBC",
      "BLOOD-ELISA",
      "BLOOD-BIOCHEMISTRY",
    ]);
  };

  return (
    <div className="card ">
      <div className="card-content collapse show">
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Button onClick={selectAll}>Select all</Button>
              <button
                onClick={printInvoice}
                disabled={!selectedBarcodes.length}
                className="btn btn-info"
              >
                Print
              </button>
            </div>
          </div>
          <div className="mt-1" ref={barcodeRef}>
            <div id={"barcodes-content"}>
              <div className="barcodes-content-container ">
                <BarcodeSticker
                  patient={patient}
                  type={"STOOL"}
                  description={"HELM, GIAR, BILHAR"}
                  bNumber={patient.barCode}
                />
                <Label
                  className="print-label"
                  checkbox
                  style={{ marginLeft: "156px", fontSize: "17px" }}
                >
                  <Input
                    checked={selectedBarcodes.includes("STOOL")}
                    onChange={(e) => {
                      handleCheckPrint("STOOL", e.target.checked);
                    }}
                    style={{ height: "15px", width: "15px" }}
                    type="checkbox"
                  />
                  Print
                </Label>
              </div>
              <div className="barcodes-content-container barcode-sticker-print">
                <BarcodeSticker
                  patient={patient}
                  type={"URINE"}
                  description={"SUGAR,AL,BILHA,ETC"}
                  bNumber={patient.barCode}
                />
                <Label
                  className="print-label"
                  checkbox
                  style={{ marginLeft: "156px", fontSize: "17px" }}
                >
                  <Input
                    checked={selectedBarcodes.includes("URINE")}
                    onChange={(e) => {
                      handleCheckPrint("URINE", e.target.checked);
                    }}
                    style={{ height: "15px", width: "15px" }}
                    type="checkbox"
                  />
                  Print
                </Label>
              </div>
              <div className="barcodes-content-container barcode-sticker-print">
                <BarcodeSticker
                  patient={patient}
                  type={"BLOOD-CBC"}
                  description={"HGB,BGROUP,MP,MFP"}
                  bNumber={patient.barCode}
                />
                <Label
                  className="print-label"
                  checkbox
                  style={{ marginLeft: "156px", fontSize: "17px" }}
                >
                  <Input
                    checked={selectedBarcodes.includes("BLOOD-CBC")}
                    onChange={(e) => {
                      handleCheckPrint("BLOOD-CBC", e.target.checked);
                    }}
                    style={{ height: "15px", width: "15px" }}
                    type="checkbox"
                  />
                  Print
                </Label>
              </div>
              <div className="barcodes-content-container barcode-sticker-print">
                <BarcodeSticker
                  patient={patient}
                  type={"BLOOD-ELISA"}
                  description={"HCV,HIV,HBsAG"}
                  bNumber={patient.barCode}
                />
                <Label
                  className="print-label"
                  checkbox
                  style={{ marginLeft: "156px", fontSize: "17px" }}
                >
                  <Input
                    checked={selectedBarcodes.includes("BLOOD-ELISA")}
                    onChange={(e) => {
                      handleCheckPrint("BLOOD-ELISA", e.target.checked);
                    }}
                    style={{ height: "15px", width: "15px" }}
                    type="checkbox"
                  />
                  Print
                </Label>
              </div>
              <div className="barcodes-content-container barcode-sticker-print">
                <BarcodeSticker
                  patient={patient}
                  type={"BLOOD-BIOCHEMISTRY"}
                  description={"GLUC,TBIL,SGPT,SGOT,CREA"}
                  bNumber={patient.barCode}
                />
                <Label
                  className="print-label"
                  checkbox
                  style={{ marginLeft: "156px", fontSize: "17px" }}
                >
                  <Input
                    checked={selectedBarcodes.includes("BLOOD-BIOCHEMISTRY")}
                    onChange={(e) => {
                      handleCheckPrint("BLOOD-BIOCHEMISTRY", e.target.checked);
                    }}
                    style={{ height: "15px", width: "15px" }}
                    type="checkbox"
                  />
                  Print
                </Label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PatientBarcodes;
